import React, { useEffect, useState } from 'react'
import Toast from '../../../helpers/Toast';
import TableComponent, { OperationsCell } from "../../TableComponent";
import { FormattedMessage, useIntl } from 'react-intl';
import { ClientService } from '../../../services/ClientService';
import { EquipmentDTO } from '../../../models/Equipment/EquipmentDTO';
import { GetEquipmentsFromClientDTO } from '../../../models/Client/GetEquipmentsFromClientDTO';
import { Row } from "reactstrap";
import { useParams } from "react-router-dom";
import ButtonComponent from '../../ButtonComponent';
import { useAvailableModulesContext } from '../../../context/AvailableModulesContext';
import { useNavigateToEquipmentCreate } from '../../../EquipmentUtilities';
import { EquipmentsFromClientProps } from '../EquipmentsFromClient';


function EquipmentsFromClientA({ ...props }: EquipmentsFromClientProps) {
    const { id } = useParams<{ id: string }>();
    const clientService = new ClientService();
    const intl = useIntl();

    //#region Módulos ativos
    const { availableModules } = useAvailableModulesContext();
    const [isActiveCarPlate, setIsActiveCarPlate] = useState<boolean>(false);
    const [isActiveErpEquipments, setIsActiveErpEquipments] = useState<boolean>(false);
    useEffect(() => {
        if (availableModules.includes("IsActiveCarPlate")) {
            setIsActiveCarPlate(true);
        }
        if (availableModules.includes("IsActiveErpEquipments")) {
            setIsActiveErpEquipments(true);
        }
    }, [availableModules]);
    //endregion

    const [equipments, setEquipments] = useState<EquipmentDTO[]>([]);
    const pageSizes: number[] = [5, 15, 30];
    const [pageSize, setPageSize] = useState<number>(pageSizes[0]);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [goToPage, setGoToPage] = useState<number>();
    const [pageCount, setPageCount] = useState(1);

    const columns = React.useMemo(
        () => [

            ...(isActiveCarPlate ? [{
                Header: <FormattedMessage id="Screens.MaintenancePlansFromClient.Table.Column.CarPlate" />,
                accessor: "carPlate",
                width: 25,
            }] : []),
            {
                Header: <FormattedMessage id="Screens.EquipmentsFromClient.Table.Column.SerialNumber" />,
                accessor: "serialNumber",
                width: 25,
            },
            {
                Header: <FormattedMessage id="Screens.EquipmentsFromClient.Table.Column.Brand" />,
                accessor: "brand",
                width: 25,
            },
            {
                Header: <FormattedMessage id="Screens.EquipmentsFromClient.Table.Column.Model" />,
                accessor: "model",
                width: 25,
            },
            {
                Header: "",
                accessor: " ",
                width: 5,
                Cell: (props: any) =>
                    OperationsCell(props.cell.row.original.erpId, "equipment"),

            },
        ],
        [isActiveCarPlate]
    );

    const GetEquipments = async (page: number, pageSize: number) => {
        setIsLoading(true);

        const data: GetEquipmentsFromClientDTO = {
            ErpId: id!,
            CurrentPage: currentPage,
            PageSize: pageSize,
        }
        var response = await clientService.GetPaginatedEquipmentsFromClient(data);

        if (response.success === false) {
            Toast.Show("error", response.message);
            setIsLoading(false);
            return;
        }

        setEquipments(response.items);
        setIsLoading(false);
        setPageCount(response.totalPages);
        setPageSize(pageSize);
        setCurrentPage(page);
        setGoToPage(0)
    }

    useEffect(() => {
        if (id && isLoading) {
            GetEquipments(currentPage ?? 1, pageSize ?? 5)
        }
    }, [])


    //#region Navegar para criação de um novo equipamento, passando dados do cliente
    const navigateToCreate = useNavigateToEquipmentCreate(); // tenho de fazer isto e não ser direto pq "React Hook "useNavigateToMaintenancePlanCreate" cannot be called inside a callback. React Hooks must be called in a React function component or a custom React Hook function"
    //endregion

    return (
        <div>
            <Row style={{ margin: "1rem 0px" }}>
                {
                    !isActiveErpEquipments &&
                    <ButtonComponent
                        text={intl.formatMessage({ id: "Screens.EquipmentsFromClient.Button.Create.Equipment" })}
                        onClick={() => navigateToCreate(props?.clientErpId, props?.clientName)}
                        xs={12}
                        sm={12}
                        md={12}
                        lg={12}
                        xl={12}
                        style={{ minHeight: "37px", minWidth: "100px", marginTop: "25px", marginBottom: "25px" }}
                    />
                }
            </Row>

            <Row style={{ margin: "1rem 0px" }}>
                <TableComponent
                    columns={columns}
                    data={equipments}
                    goToPage={goToPage}
                    initialPage={currentPage}
                    pageCount={pageCount}
                    initialPageSize={pageSize}
                    pageSizes={pageSizes}
                    manualPagination={true}
                    loading={isLoading}
                    fetchData={GetEquipments}
                    initialSortBy={[]}
                    disableSortBy={true}
                    dontOrderFirstCollumn={true}
                />
            </Row>
        </div>

    )
}

export default EquipmentsFromClientA